import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "overlay", "arrow"]

  connect() {
    this.isSidebarOpen = false
    // Listen for mobile menu toggle from navbar
    document.addEventListener('mobile-menu-toggled', this.handleMobileMenuToggle.bind(this))
  }

  disconnect() {
    document.removeEventListener('mobile-menu-toggled', this.handleMobileMenuToggle.bind(this))
  }

  handleMobileMenuToggle(event) {
    // This will be called when the navbar's mobile menu is toggled
    this.toggle()
  }

  toggle() {
    if (this.isSidebarOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.isSidebarOpen = true
    const sidebar = this.sidebarTarget
    const overlay = this.overlayTarget
    const arrow = this.arrowTarget
    
    // Show sidebar
    sidebar.classList.remove('-translate-x-full', 'hidden')
    sidebar.classList.add('translate-x-0', 'lg:block')
    
    // Rotate arrow to point left (sidebar is open)
    if (arrow) {
      arrow.style.transform = 'rotate(180deg)'
    }
    
    // Show overlay on mobile
    if (window.innerWidth < 1024) {
      overlay.classList.remove('hidden')
    }
  }

  close() {
    this.isSidebarOpen = false
    const sidebar = this.sidebarTarget
    const overlay = this.overlayTarget
    const arrow = this.arrowTarget
    
    // Hide sidebar
    sidebar.classList.add('-translate-x-full', 'hidden')
    sidebar.classList.remove('translate-x-0', 'lg:block')
    
    // Rotate arrow to point right (sidebar is closed)
    if (arrow) {
      arrow.style.transform = 'rotate(0deg)'
    }
    
    // Hide overlay
    overlay.classList.add('hidden')
  }
}
